import { Attribute } from './Attribute.js';

export const AMOUNT_ATTRIBUTE_ID = 'Amount';
export const AMOUNT_ATTRIBUTE_TYPE = 'AmountAttribute';

/**
 * @property {number} value
 * @property {number} previousValue
 * @property {AmountAttributeOption[]} options
 * @property {boolean} isReadOnly
 */
export class AmountAttribute extends Attribute {
  constructor({ value, previousValue = null, options, isReadOnly = false }) {
    super();
    this.value = value;
    this.previousValue = previousValue;
    this.options = options;
    this.isReadOnly = isReadOnly;
    this.type = AMOUNT_ATTRIBUTE_TYPE;
  }

  /**
   *
   * @param {number} value
   * @return {null|string}
   */
  getLabelByValue(value) {
    if (!this.options) {
      return null;
    }

    const option = this.options.find(o => o.value === value);
    return option ? option.label : null;
  }

  isChanging() {
    return this.previousValue !== null;
  }
}
